import React, { createContext, useContext, useState, useCallback } from 'react';
import { fetchData, postData, putData, deleteData } from '../../services/Api';
import { useAlert } from '../geral/AlertContext';
import { useMessage } from '../geral/MessageContext';


const PedidoItemConjuntoContext = createContext();

export const usePedidoItemConjunto = () => useContext(PedidoItemConjuntoContext);

export const PedidoItemConjuntoProvider = ({ children }) => {
    const [pedidoItemConjuntos, setPedidoItemConjuntos] = useState([]);
    //const [pedidoItemConjuntoSel, setPedidoItemConjuntoSel] = useState();
    const { showAlert } = useAlert();
    const { showMessage } = useMessage();

    const fetchPedidoItemConjuntos = useCallback(async (pedidoItemId) => {
        if (!pedidoItemId) return;

        try {
            const result = await fetchData(`/PedidoItemConjunto/GetByPedidoItemId?pedidoItemId=${pedidoItemId}`);
            setPedidoItemConjuntos(result);
        } catch (error) {
            console.error("Erro ao buscar itens do conjunto do pedido:", error);
            showMessage(`Erro ao buscar itens do conjunto do pedido! ${error?.message || error}`, 'danger');
        }
    }, [showMessage]);

    const addPedidoItemConjunto = async (item) => {
        try {
            const result = await postData('/PedidoItemConjunto', item);
            setPedidoItemConjuntos([...pedidoItemConjuntos, result]);
            showAlert('Item do conjunto do pedido adicionado com sucesso!');
        } catch (error) {
            console.error("Erro ao adicionar item do conjunto do pedido:", error);
            showMessage('Erro ao adicionar item do conjunto do pedido!\n' + error, 'danger');
        }
    };

    const updatePedidoItemConjunto = async (item) => {
        try {
            const result = await putData('/PedidoItemConjunto', item);
            setPedidoItemConjuntos((prev) =>
                prev.map((i) => (i.id === result.id ? result : i))
            );
            showAlert('Item do conjunto do pedido alterado com sucesso!');
        } catch (error) {
            console.error("Erro ao atualizar item do conjunto do pedido:", error);
            showAlert('Erro ao alterar item do conjunto do pedido!', 'danger');
        }
    };

    const deletePedidoItemConjunto = async (id) => {
        try {
            await deleteData('/PedidoItemConjunto', { id });
            setPedidoItemConjuntos(pedidoItemConjuntos.filter(i => i.id !== id));
            showAlert('Item do conjunto do pedido excluído com sucesso!');
        } catch (error) {
            console.error("Erro ao excluir item do conjunto do pedido:", error);
            showAlert('Erro ao excluir item do conjunto do pedido!', 'danger');
        }
    };

    return (
        <PedidoItemConjuntoContext.Provider value={{
            pedidoItemConjuntos,
            fetchPedidoItemConjuntos,
            addPedidoItemConjunto,
            updatePedidoItemConjunto,
            deletePedidoItemConjunto
        }}>
            {children}
        </PedidoItemConjuntoContext.Provider>
    );
};